module.exports = __webpack_public_path__ + "img/hohlsaum_lichtgrau_ral7035.ee65d8e3.jpg";